import { ref, watch } from 'vue'
import { useFrontEndDataQuery } from '../queries/useFrontEndDataQuery'
import { DropdownOption } from '@/api/contracts/models'

export function useUrlScopeOperators() {
   const { data: frontendData } = useFrontEndDataQuery()
   const result = ref<undefined | DropdownOption[]>(undefined)

   const setUrlScopeOperators = () => {
      result.value = frontendData.value!.urlScopeOperators
   }

   watch(
      [frontendData],
      () => {
         if (frontendData.value) {
            setUrlScopeOperators()
         }
      },
      { immediate: true, deep: true }
   )

   return result
}
